import React from 'react';
import { UnitEnum } from '@teko-builder/types/pb';
import * as DSIcons from '@teko-builder/icons';

const getSizeWithUnit = (value) => {
    if (typeof (value === null || value === void 0 ? void 0 : value.size) === 'number') {
        return `${value === null || value === void 0 ? void 0 : value.size}${(value === null || value === void 0 ? void 0 : value.unit) || UnitEnum.pixel}`;
    }
};
const getPropsIcon = (icon) => {
    const style = {};
    if (icon === null || icon === void 0 ? void 0 : icon.color) {
        style.color = icon.color;
    }
    if (icon === null || icon === void 0 ? void 0 : icon.size) {
        style.fontSize = icon.size;
    }
    return { style };
};
const getIconCompoment = (icon) => {
    const DsIcon = DSIcons[icon === null || icon === void 0 ? void 0 : icon.name];
    const IconComponent = !!DsIcon
        ? React.createElement(DsIcon, getPropsIcon({
            color: icon === null || icon === void 0 ? void 0 : icon.color,
            size: icon === null || icon === void 0 ? void 0 : icon.size,
        }))
        : null;
    return IconComponent;
};
const addPaddingNumber = (number) => number === null || number === void 0 ? void 0 : number.toString().padStart(2, '0');
const calculateTimeDelta = (startTime, endTime) => {
    const fromTimestamp = startTime.getTime();
    const endTimestamp = endTime.getTime();
    const durationInSecond = Math.max(0, Math.round((endTimestamp - fromTimestamp) / 1000));
    return {
        durationInSecond,
        days: Math.floor(durationInSecond / (3600 * 24)),
        hours: Math.floor((durationInSecond / 3600) % 24),
        minutes: Math.floor((durationInSecond / 60) % 60),
        seconds: Math.floor(durationInSecond % 60),
    };
};
const getParamsFromUrl = (url) => {
    return Object.fromEntries(new URLSearchParams(url).entries());
};

export { addPaddingNumber as a, getParamsFromUrl as b, calculateTimeDelta as c, getPropsIcon as d, getSizeWithUnit as e, getIconCompoment as g };
